import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import PrescribersTableEmpty from './PrescribersTableEmpty';
import PrescribersTableRow from './PrescribersTableRow';

const styles = theme => ({
  paper: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 250px)',
    overflowX: 'auto',
    overflowY: 'visible',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 178px)',
      transition: theme.transitions.create(['height'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  paperMobileFilterExpanded: {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 268px)',
    },
  },
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  table: {
    minWidth: 500,
  },
  hiddenCell: {
    fontSize: 0,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 0,
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
  },
});

const PrescribersTable = ({
  items,
  count,
  classes,
  loading,
  mobileFilterExpanded,
  onScroll,
  scrollRef,
}) => (
  <div>
    {(loading === 0 || items.length > 0) && (
      <Typography className={classes.typography}>
        {`(${count})`}
      </Typography>
    )}
    <RootRef rootRef={scrollRef}>
    <Paper
      className={classNames(classes.paper, {
        [classes.paperMobileFilterExpanded]: mobileFilterExpanded,
      })}
      onScroll={onScroll}
    >
    {(loading === 0 && items.length === 0) &&
      <PrescribersTableEmpty />
    }
    {items.length > 0 &&
      <Table className={classes.table}>
        <TableHead
          className={classes.tableHead}
        >
          <TableRow>
            <TableCell>Prescriber</TableCell>
            <TableCell>Phone</TableCell>
            {/* <TableCell>Fax</TableCell> */}
            <TableCell>Email</TableCell>
            <TableCell>NPI</TableCell>
            <TableCell>LIC</TableCell>
            <TableCell>DEA</TableCell>
            <TableCell>Type</TableCell>
            <TableCell className={classes.hiddenCell}>Links</TableCell>
            <TableCell className={classes.hiddenCell}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(item => (
            <PrescribersTableRow
              key={item.ID}
              {...item}
            />
          ))}
        </TableBody>
      </Table>
    }
    </Paper>
    </RootRef>
  </div>
);

PrescribersTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number,
  mobileFilterExpanded: PropTypes.bool,
  onScroll: PropTypes.func,
  scrollRef: PropTypes.func,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    hiddenCell: PropTypes.string.isRequired,
  }).isRequired,
};

PrescribersTable.defaultProps = {
  loading: 0,
  mobileFilterExpanded: false,
  onScroll: undefined,
  scrollRef: undefined,
};

export default withStyles(styles)(PrescribersTable);



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersTable/PrescribersTable.js